import styled from 'styled-components';

import { fonts, Link } from '@dreryk/react-components';

export const StyledPractitionerNameLink = styled(Link)`
   font-weight: ${fonts.fontWeightBold};
`;

StyledPractitionerNameLink.displayName = 'StyledPractitionerNameLink';
